export const getImageLoader =
  (mapper: (width: number) => string, srcName: string) =>
  ({ src, width }: { src: string; width: number }) => {
    const sizeName = mapper(width);
    return sizeName ? src.replace(srcName, `${sizeName}`) : src;
  };
